import { View } from 'ol';

/**
 * The loupe's {@link View} while the loupe map is rendering, else null.
 *
 * Glyph images are drawn as an Icon on a Point anchored to the rendering map's
 * view center (see `Glyph.getAnchorAndCoords`): the anchor offset makes the
 * image land on the box, and pinning the point at the always-visible view
 * center stops OpenLayers culling the (large) icon by its anchor point. That
 * logic is bound to the single primary map, so in the loupe (a second map with
 * a different center) the icon's point sits at the primary center and is culled
 * out of the loupe viewport once the cursor moves away — intermittent blank
 * glyphs.
 *
 * The loupe publishes its view here on the map-level `precompose` event (which
 * fires before any layer's prepareFrame, where styles run) and clears it on
 * `postcompose`, so glyph anchoring uses the loupe's own center while it renders
 * and the primary map's center otherwise. The two maps render in separate,
 * non-interleaving frames, so the value never leaks across maps.
 */
let loupeRenderView: View | null = null;

export const setLoupeRenderView = (view: View | null): void => {
  loupeRenderView = view;
};

export const getLoupeRenderView = (): View | null => loupeRenderView;
